import { Component } from "@angular/core";
import { LoginService } from "../app/login.service";
import { CommerrorService } from "./commerror.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
  title = "Aweb";
  constructor(
    public loginS: LoginService, // the template gates the Support Center widget on it
    private commerrorService: CommerrorService,
    // public translate: TranslateService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    // this.translate.setDefaultLang("en-US");

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // this.translate.use("en-US");
  }

  ngOnInit() {
    window.addEventListener("online", () => {
      this.commerrorService.retryFailedRequests();
    });
    const url = new URL(window.location.href);
    // Clean '_v' we added to force the browser to get the new V
    if (url.searchParams.has('_v')) {
      url.searchParams.delete('_v');
      window.history.replaceState({}, document.title, url.toString());
    }
  }
}
